import PropTypes from 'prop-types';
import { Button, Dialog, DialogTitle, DialogActions, DialogContent } from '@mui/material';

const ConfirmDialog = ({ title, content, action, open, onClose, ...other }) => (
    <Dialog fullWidth maxWidth='xs' open={open} onClose={onClose} {...other}>
        <DialogTitle sx={{ pb: 2 }}>{title}</DialogTitle>

        {content && <DialogContent sx={{ typography: 'body2' }}> {content} </DialogContent>}

        <DialogActions>
            {action}

            <Button variant='outlined' color='inherit' onClick={onClose}>
                Cancel
            </Button>
        </DialogActions>
    </Dialog>
);

export default ConfirmDialog;

ConfirmDialog.propTypes = {
    action: PropTypes.node,
    content: PropTypes.node,
    onClose: PropTypes.func,
    open: PropTypes.bool,
    title: PropTypes.string,
};
